import React from 'react';

export const ChangeAnalysisWidgetWrapper = ({ children, compareVersionId, ...props }) => {
    return compareVersionId
        ? React.Children.map(children, (child) => {
              return React.cloneElement(child, {
                  compareVersionId,
                  ...props,
              });
          })
        : null;
};
